import { FC, memo } from "react";

import { SVG_MUI } from "@ryde/assets";

import {
  ExplanationIconStyled,
  ExplanationTooltipContent,
} from "../../dynamic-forms/templates-edit/_parts/explanation-icon.styled";
import { FramerTooltip } from "../tooltips";
import { IBulkActionItem } from "./bulk-actions.models";

interface IBulkActionsRowProps {
  action: IBulkActionItem;
}

// The hint must show up instantly: no fade, no scale and (with the translate distance
// passed below) no slide when the tooltip opens - only the closing fade is kept.
const HINT_TOOLTIP_ANIMATION = {
  initial: { opacity: 1, scale: 1 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 1, transition: { duration: 0.1 } },
};

const BulkActionsRowContent: FC<IBulkActionsRowProps> = ({ action }) => {
  const { key, label, hint, icon: ActionIcon, onClick, isDisabled } = action;

  return (
    <li className="bulk-action-item">
      <button
        type="button"
        className="bulk-action-row"
        data-e2e-custom={`bulk-action-${key}`}
        disabled={isDisabled}
        onClick={onClick}
      >
        <span className="bulk-action-icon">
          <ActionIcon aria-hidden="true" />
        </span>
        <span className="bulk-action-label">{label}</span>
        <SVG_MUI.ArrowsToDottedLineSVG className="bulk-action-arrow rtl_rotate" />
      </button>
      {/* FramerTooltip already no-ops on mobile; the styled block hides the glyph there. */}
      {Boolean(hint) && (
        <FramerTooltip
          content={
            <ExplanationTooltipContent>{hint}</ExplanationTooltipContent>
          }
          rtlStrippedLeftPlacement
          animation={HINT_TOOLTIP_ANIMATION}
          openingAnimationTranslateDistance={0}
        >
          <span className="bulk-action-hint" role="img" aria-label={hint}>
            <ExplanationIconStyled />
          </span>
        </FramerTooltip>
      )}
    </li>
  );
};

export const BulkActionsRow = memo(BulkActionsRowContent);
